export enum ClientTypes {
  GET_CLIENTS = '@@clients/GET_CLIENTS',
  GET_CLIENTS_SUCCESS = '@@clients/GET_CLIENTS_SUCCESS',
  GET_CLIENTS_FAIL = '@@clients/GET_CLIENTS_FAIL',

  GET_CLIENTS_DETAIL = '@@clients/GET_CLIENTS_DETAIL',
  GET_CLIENTS_DETAIL_SUCCESS = '@@clients/GET_CLIENTS_DETAIL_SUCCESS',
  GET_CLIENTS_DETAIL_FAIL = '@@clients/GET_CLIENTS_DETAIL_FAIL',

  ADD_CLIENTS = '@@clients/ADD_CLIENTS',
  ADD_CLIENTS_SUCCESS = '@@clients/ADD_CLIENTS_SUCCESS',
  ADD_CLIENTS_FAIL = '@@clients/ADD_CLIENTS_FAIL',

  DELETE_CLIENTS = '@@clients/DELETE_CLIENTS',
  DELETE_CLIENTS_SUCCESS = '@@clients/DELETE_CLIENTS_SUCCESS',
  DELETE_CLIENTS_FAIL = '@@clients/DELETE_CLIENTS_FAIL',

  UPDATE_CLIENTS = '@@clients/UPDATE_CLIENTS',
  UPDATE_CLIENTS_SUCCESS = '@@clients/UPDATE_CLIENTS_SUCCESS',
  UPDATE_CLIENTS_FAIL = '@@clients/UPDATE_CLIENTS_FAIL',

  GET_BRAND_CUSTOM = '@@clients/GET_BRAND_CUSTOM',
  GET_BRAND_CUSTOM_SUCCESS = '@@clients/GET_BRAND_CUSTOM_SUCCESS',
  GET_BRAND_CUSTOM_FAIL = '@@clients/GET_BRAND_CUSTOM_FAIL',

  UPDATE_IMAGE_CLIENTS = '@@clients/UPDATE_IMAGE_CLIENTS',
  UPDATE_IMAGE_CLIENTS_SUCCESS = '@@clients/UPDATE_IMAGE_CLIENTS_SUCCESS',
  UPDATE_IMAGE_CLIENTS_FAIL = '@@clients/UPDATE_IMAGE_CLIENTS_FAIL',
  
  SEND_TEST_EMAIL = '@@clients/SEND_TEST_EMAIL',
  SEND_TEST_EMAIL_SUCCESS = '@@clients/SEND_TEST_EMAIL_SUCCESS',
  SEND_TEST_EMAIL_FAIL = '@@clients/SEND_TEST_EMAIL_FAIL',
}
